export default "__VITE_ASSET__4d3eea04__"